import OadpAttributeNumber from './oadp-attribute-number';
export default OadpAttributeNumber;
